
import { createContext, useContext } from "react";
import useModuloControleInterno from "../hooks/useModuloControleInterno"; 

const ModuloControleContext = createContext(null);

export const ModuloControleProvider = ({ children }) => {
  const context = useModuloControleInterno(); 
  
  return (
    <ModuloControleContext.Provider value={context}>
      {children}
    </ModuloControleContext.Provider>
  );
};

export const useModuloControle = () => {
  const context = useContext(ModuloControleContext);
  if (!context) {
    throw new Error("useModuloControle must be used within a ModuloControleProvider");
  }
  return context;
};
